<template>
  <div id="app">
    <div class="col-12 col-md-4 offset-md-4 mt-5">
      <div class="text-center mb-5 mt-1">
        <h2><v-icon name="bi-x-circle" scale="6" /></h2>
        <h3>¡Ups! Algo ha salido mal</h3><br>
        <h5>Su sesión ha caducado o no está autorizado para acceder a esta página.</h5>
      </div>
      <div class="col-12 mt-1 text-center">
        <button class="btn btn-primary" @click="back()">Volver</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    back() {
      this.$router.back()
    },
  },
};
</script>

<style lang="scss">

</style>
